import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

/**
 * Permite que qualquer parte da aplicação solicite a abertura do modal de troca de
 * unidade/entidade, que é exibido pelo HeaderComponent (visível em todas as telas).
 */
@Injectable({ providedIn: "root" })
export class TrocaEntidadeService {
  private readonly solicitarAberturaSubject = new Subject<void>();
  readonly solicitarAbertura$ = this.solicitarAberturaSubject.asObservable();

  solicitarAbertura() {
    this.solicitarAberturaSubject.next();
  }
}
